import React, { useState } from "react";
//
import useTable from "../useTable";

import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import axios from "axios";
import TablaOrdenesPorCargar from "./tablaOrdenesPorCargar";
import TablaOrdenesCargadas from "./tablaOrdenesCargadas";
import CatalogoEfiscal from "../../catalogos/catalogoEfiscal";
import { SearchInput, Input } from "../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button";

const TablaCargarOrdenesPagar = (props) => {
  var op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CÓDIGO",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CONCEPTO",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];

  const [mostrar, setMostrar] = useState(false);

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records] = useState([]);
  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const {} = useTable(records, headCells, filterFn);

  const handleCloseSi = () => {
    setActivate(false);
  };

  const cerrar = () => {
    props.setTabla(0);
  };

  return (
    <div className="col-8 m-0 p-0 mx-auto mt-5">
        <header className="col-12 m-0 mb-2 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top">
          <h3 className="m-0">
            Cargar Ordenes por Pagar
          </h3>
          <a
            type="button"
            onClick={cerrar}
          >
            salir<i className="fas fa-times ms-2"></i>
          </a>
        </header>
        <fieldset className="col-12 border-azul rounded p-2 m-0 d-flex flex-wrap">
          <legend className="float-none m-0 w-auto">Ejercicio Fiscal</legend>
          <div className="col-3 p-0 pr-2 m-0">
            <SearchInput
              label="Código:"
              onClickButton={() => {
                setMostrar(true);
              }}
              id="idprov"
            />
          </div>
          <div className="col-9 p-0 m-0">
            <Input label="Descripción:" disabled={true} id="inputDireccion" />
          </div>
        </fieldset>
        <ul className="nav nav-tabs mt-2" id="ex-with-icons" role="tablist">
          <li className="nav-item" role="presentation">
            <a
              className="nav-link active"
              id="datosTributarios"
              data-bs-toggle="tab"
              type="button"
              data-bs-target="#tributarios"
              role="tab"
              aria-controls="tributarios"
              aria-selected="true"
            >
              Ordenes por Pagar
            </a>
          </li>
          <li className="nav-item" role="presentation">
            <a
              className="nav-link"
              id="datosTributarios2"
              data-bs-toggle="tab"
              type="button"
              data-bs-target="#tributarios2"
              role="tab"
              aria-controls="tributarios2"
              aria-selected="false"
            >
              Ordenes Cargadas
            </a>
          </li>
        </ul>
        <div className="tab-content py-1" id="myTabContent">
          <div
            className="tab-pane fade show active"
            id="tributarios"
            role="tabpanel"
            aria-labelledby="datosTributarios"
          >
            <TablaOrdenesPorCargar />
          </div>
          <div
            className="tab-pane"
            id="tributarios2"
            role="tabpanel"
            aria-labelledby="datosTributarios2"
          >
            <TablaOrdenesCargadas />
          </div>
        </div>
        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-end gap-2">
          <SuccessButton>Aceptar</SuccessButton>
          <DangerButton>Cancelar</DangerButton>
        </div>
      <CatalogoEfiscal
        show={mostrar}
        onHideCancela={() => {
          setMostrar(false);
        }}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
};
export default TablaCargarOrdenesPagar;
